import classnames from 'classnames'
import { tagsStringCombined } from 'helpers/tags'
import PropTypes from 'prop-types'
import { TypeBase, TypeCaption } from 'raspberry-pi-bits'
import React from 'react'
import { translate } from 'react-i18next'

import ProgressCard from './ProgressCard/ProgressCard'

const linkUrl = (locale, slug, step) => {
  return `/${locale}/projects/${slug}/${step}`
}

const CarouselProjectCard = ({
  horizontal,
  locale,
  progress,
  showProgress = true,
  t,
}) => {
  const descriptionClassNames = classnames('c-progress-card__description', {
    'c-progress-card__description--horizontal': horizontal,
  })

  const tagsClassNames = classnames('c-progress-card__tags', {
    'c-progress-card__tags--horizontal': horizontal,
  })
  return (
    <ProgressCard
      data-on="click"
      data-event-category="ProjectCard"
      data-event-action="Clicked"
      data-event-label={window.location}
      horizontal={horizontal}
      progress={progress}
      showProgress={showProgress}
      to={linkUrl(
        locale,
        progress.repositoryName,
        progress.step ? progress.step : ''
      )}
    >
      <TypeBase element="p" className={descriptionClassNames}>
        {progress.description}
      </TypeBase>
      <TypeCaption className={tagsClassNames}>
        {tagsStringCombined(locale, t, {
          hardware: progress.tags.hardware,
          software: progress.tags.software,
        })}
      </TypeCaption>
    </ProgressCard>
  )
}

CarouselProjectCard.propTypes = {
  horizontal: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  progress: PropTypes.object.isRequired,
  showProgress: PropTypes.bool,
  isFavourite: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

export default translate('translations')(CarouselProjectCard)
